import { ColumnsDropzone } from 'components/ui';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { DropTarget } from 'react-dnd';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { emptyFn } from 'utils/common';
import { addReportToZone, addSlotToZone } from '../flow/actions';

const defaultProps = {
  addReportToZone: emptyFn,
  addSlotToZone: emptyFn
};
const propTypes = {
  addReportToZone: PropTypes.func,
  addSlotToZone: PropTypes.func
};

class Dropzone extends Component {
  componentDidMount() {}

  render() {
    const { isOver, connectDropTarget, children } = this.props;
    return connectDropTarget(
      <div>
        <ColumnsDropzone
          isOver={!!isOver}
          description={
            <FormattedMessage id="page.DashboardSettings_Details.dropZone" />
          }
        >
          {children}
        </ColumnsDropzone>
      </div>
    );
  }
}

const spec = {
  drop: (props, monitor) => {
    // Skip if drag item is handled by other drop target
    if (monitor.didDrop()) return;

    const { id, dragType } = monitor.getItem();
    if (dragType === 'DRAG_REPORT') {
      props.addReportToZone(id, props.x);
    } else if (dragType === 'DRAG_SLOT') {
      props.addSlotToZone(id, props.x);
    }
  }
};
const collect = (connector, monitor) => ({
  connectDropTarget: connector.dropTarget(),
  isOver: monitor.isOver()
});

Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = propTypes;

const mapState = ({ dashboardSettings }) => ({
  slots: dashboardSettings.details.slots
});
const mapDispatch = {
  addReportToZone,
  addSlotToZone
};
const enhancers = compose(
  connect(
    mapState,
    mapDispatch
  ),
  DropTarget(['DRAG_REPORT', 'DRAG_SLOT'], spec, collect)
);
export default enhancers(Dropzone);



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Details/components/DropZone.jsx